.objectPage {
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: var(--size-8);
	overflow-y: auto;

	> .header {
		display: flex;
		flex-direction: column;

		> .backlink {
			display: flex;
			align-self: flex-start;
			align-items: center;
			gap: var(--size-3);
			font-weight: 600;
			color: var(--color-link);
			margin-bottom: var(--size-3);

			&:hover,
			&:focus-visible {
				text-decoration: underline;
			}
		}

		> .title {
			display: flex;
			align-items: center;
			gap: var(--size-4);
			font-size: var(--text-title);
			font-weight: 600;
		}

		> .desc {
			font-size: var(--text-subtitle-2);
			color: var(--color-text-subtle);
		}
	}

	> .actions {
		display: flex;
		align-items: center;
		gap: var(--size-3);
	}

	> .main {
		display: grid;
		gap: var(--size-10);
		grid-template-columns: 1fr 30%;

		> * {
			display: flex;
			flex-direction: column;
			gap: var(--size-8);
		}
	}
}

.objectPageSection {
	display: flex;
	flex-direction: column;
	gap: var(--size-2);

	> .cell {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		gap: var(--size-2);

		&:empty::after {
			content: attr(data-empty, "None");
			color: var(--color-text-subtle);
		}
	}

	> .header {
		display: flex;
		align-items: center;
		gap: var(--size-5);

		> .title {
			font-size: var(--text-subtitle-2);
			font-weight: 600;
		}

		> .actions {
			display: flex;
			align-items: center;
		}
	}
}
